import {gql} from "@apollo/client";

export const GET_ALL_PARTNERS = gql`
    query GetPartners {
        getPartners {
            id
            name
            key
            companyUrl
            appUrl
            createdBy
            updatedBy
            createdAt
            updatedAt
            status
            value: id
            label: name
        }
    }

`;
